import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2"

/**
 * The `bulk_list` filter row in the filters dialog. The list is created by the Bulk
 * search dialog (three-dots menu), so this row only describes it; removing the row stops
 * filtering by it. A row added by hand has no list yet and stays incomplete.
 */
export default function BulkListFilterBody({ fieldConfig }) {
  return (
    <Grid xs={12}>
      <Typography variant="body2" color="text.secondary">
        {fieldConfig.value
          ? `${
              fieldConfig.label || `Bulk search list ${fieldConfig.value}`
            }. Run Bulk search again to replace it, or delete this row to remove it.`
          : "Use Bulk search in the three-dots menu to create the list. It appears here once the search is done."}
      </Typography>
    </Grid>
  )
}
